module.exports = __webpack_public_path__ + "fb9072477a2d3e6069784a853858eea6.svg";